import { defineStore } from 'pinia'
import api from '@/utils/api'
import { API_ROUTES } from '@/const/apiRoutes'
import type { ReportsState } from '@/types/reports'

const pageSize = 20

export const useReportsStore = defineStore('reports', {
  state: (): ReportsState => ({
    reports: [],
    loading: false,
    error: null,
    pagination: {
      totalPages: 1,
      currentPage: 1
    },
    filters: {
      type: 'all',
      search: ''
    },
    totalCount: 0
  }),

  getters: {
    hasReports: (state) => state.reports.length > 0,
    isPaginated: (state) => state.pagination.totalPages > 1
  },

  actions: {
    async fetchReports({ page = 1 } = {}) {
      this.loading = true
      this.error = null
      try {
        const params: Record<string, any> = { page, page_size: pageSize }
        
        // Add type filter
        if (this.filters.type !== 'all') {
          params.type = this.filters.type
        }
        
        // Add search if present
        if (this.filters.search) {
          params.search = this.filters.search
        }

        const response = await api.get(API_ROUTES.GET_FELLOW_REPORTS, { params })
        this.reports = response.data.results
        this.totalCount = response.data.count
        this.pagination = {
          totalPages: Math.ceil(response.data.count / pageSize),
          currentPage: page
        }
      } catch (error) {
        console.error('Error fetching reports:', error)
        this.error = 'Failed to fetch reports'
      } finally {
        this.loading = false
      }
    },

    setFilter(type: 'all' | 'reports' | 'strikes') {
      this.filters.type = type
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.fetchReports({ page: 1 }) // Reset to first page when filter changes
    },

    setSearch(search: string) {
      this.filters.search = search
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.fetchReports({ page: 1 }) // Reset to first page when search changes
    }
  }
})